(() => {
  const PDP = {
    modals: {
      init() {
        const toggle = (id, show) => {
          const modal = document.querySelector(`[data-modal-id="${id}"]`);
          if (modal) modal.classList.toggle('visible', show);
        };

        document.querySelectorAll('[data-open-modal-id]').forEach(btn =>
          btn.addEventListener('click', () => toggle(btn.dataset.openModalId, true))
        );

        document.querySelectorAll('[data-close-modal-id]').forEach(btn =>
          btn.addEventListener('click', () => toggle(btn.dataset.closeModalId, false))
        );
      }
    },

    carousels: {
      selectors: {
        gallery: '[data-carousel-id="pdp-new-atf-gallery"]',
        galleryThumbs: '[data-carousel-id="pdp-new-atf-gallery-thumbs"]'
      },

      ensureSlick() {
        if (!window.jQuery || !jQuery.fn.slick) {
          console.error('Slick Carousel requires jQuery.');
          return false;
        }
        return true;
      },

      buildArrows() {
        return {
          prev: `<button class="pdp-new-carousel-arrow pdp-new-carousel-arrow-small pdp-new-carousel-arrow-left" data-gallery-prev aria-label="Previous">
            <svg fill="#000000" viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"/></svg>
          </button>`,
          next: `<button class="pdp-new-carousel-arrow pdp-new-carousel-arrow-small pdp-new-carousel-arrow-right" data-gallery-next aria-label="Next">
            <svg fill="#000000" viewBox="0 0 256 256"><path d="M90.34,202.34a8,8,0,0,0,11.32,11.32l80-80a8,8,0,0,0,0-11.32l-80-80a8,8,0,0,0-11.32,11.32L164.69,128Z"/></svg>
          </button>`
        };
      },

      getSlideCount(selector, slideSelector) {
        const el = document.querySelector(selector);
        if (!el) return 0;

        return el.querySelectorAll(slideSelector).length;
      },

      getGalleryCarouselConfigs() {
        const { gallery, galleryThumbs } = this.selectors;
        const thumbCount = this.getSlideCount(galleryThumbs, '.pdp-new-atf-gallery-thumb');

        if (!thumbCount) return [];

        return [
          {
            selector: gallery,
            options: {
              slidesToShow: 1,
              slidesToScroll: 1,
              mobileFirst: true,
              infinite: thumbCount > 1,
              dots: false,
              fade: false,
              focusOnSelect: true,
              adaptiveHeight: false
            }
          }
        ];
      },
      initGalleryThumbs() {
        const { gallery, galleryThumbs } = this.selectors;
        const galleryEl = document.querySelector(gallery);
        const thumbsEl = document.querySelector(galleryThumbs);

        if (!galleryEl || !thumbsEl) return;

        const thumbs = Array.from(thumbsEl.querySelectorAll('.pdp-new-atf-gallery-thumb'));
        if (!thumbs.length) return;

        const setActiveThumb = index => {
          thumbs.forEach(thumb => thumb.classList.remove('is-active'));
          if (thumbs[index]) thumbs[index].classList.add('is-active');
        };

        thumbs.forEach((thumb, index) => {
          thumb.addEventListener('click', () => {
            jQuery(galleryEl).slick('slickGoTo', index);
            setActiveThumb(index);
          });
        });

        jQuery(galleryEl).on('afterChange', (event, slick, currentSlide) => {
          setActiveThumb(currentSlide);
        });

        setActiveThumb(0);
      },
      initCarousel(selector, options = {}) {
        if (!this.ensureSlick()) return;

        const el = document.querySelector(selector);
        if (!el || jQuery(el).hasClass('slick-initialized')) return;

        const { prev, next } = this.buildArrows();

        const defaults = {
          arrows: true,
          prevArrow: prev,
          nextArrow: next,
          adaptiveHeight: true
        };

        jQuery(el).slick({ ...defaults, ...options });
      },

      initAll() {
        const standardCarousels = [
          {
            selector: '[data-carousel-id="pdp-new-related-products"]',
            options: {
              infinite: true,
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false,
              adaptiveHeight: true
            }
          },
          {
            selector: '[data-carousel-id="pdp-new-testimonials"]',
            options: {
              slidesToShow: 1,
              slidesToScroll: 1,
              mobileFirst: true,
              infinite: true,
              dots: false,
              fade: false,
              focusOnSelect: true
            }
          },
          {
            selector: '[data-carousel-id="pdp-new-instructions-bundle"]',
            options: {
              slidesToShow: 1,
              slidesToScroll: 1,
              mobileFirst: true,
              infinite: true,
              dots: false,
              fade: false,
              focusOnSelect: true,
              adaptiveHeight: false
            }
          }
        ];

        [
          ...standardCarousels,
          ...this.getGalleryCarouselConfigs()
        ].forEach(({ selector, options }) => {
          if (document.querySelector(selector)) this.initCarousel(selector, options);
        });
        this.initGalleryThumbs();
      },

      handleResize() {
        clearTimeout(this._resizeTimer);

        this._resizeTimer = setTimeout(() => {
          document.querySelectorAll('[data-carousel-id]').forEach(c => {
            if (jQuery(c).hasClass('slick-initialized')) {
              jQuery(c).slick('setPosition');
            }
          });
        }, 250);
      }
    },

    trackPageView() {
      if (typeof oaiq === 'function') {
        oaiq("measure", "page_viewed", {
          type: "contents"
        });
      } else if (retries > 0) {
        setTimeout(() => this.trackPageView(retries - 1), 100);
      } else {
        console.warn('oaiq not found after multiple retries');
      }
    },
    init() {
      this.modals.init();
      this.carousels.initAll();

      this.trackPageView();
    }
  };

  document.addEventListener('DOMContentLoaded', () => PDP.init());
})();